// spreadsheet utils
import * as R from 'ramda'
import * as xlsx from 'xlsx'
// import { parseCandidateRow, isValidCandidate } from 'utils/parseCandidateData'

// const xlsx = await import('xlsx')

// Worksheet -> [[*]]
const sheetToMatrix = sheet => xlsx.utils.sheet_to_json(sheet, { header: 1 })

const correctHeader = ['name', 'email', 'phone']

const pedanticParseSheet = sheet => {
  // headers of spreadsheet must be exactly ['name', 'email', 'phone']
  // returns [{name, mail, phone}]
  // convert sheet object to array of arrays
  const [header, ...rows] = sheetToMatrix(sheet)
  if (R.equals(correctHeader, header.slice(0, 3)))
    return R.pipe(
      R.map(([name, email, phone]) => ({ name, email, phone })),
      R.filter(R.prop('email')),
    )(rows)
  throw new Error(
    `wrong spreadsheet headers: ${header}, expected ${correctHeader}`,
  )
}

const extension = R.pipe(
  R.split('.'),
  R.last,
)

export const processWorkbooks = R.pipe(
  R.chain(
    R.pipe(
      R.propOr({}, 'Sheets'),
      R.values,
    ),
  ),
  R.map(pedanticParseSheet),
  // R.map(sheetToMatrix),
  R.unnest,
  // R.map(parseCandidateRow),
  // R.filter(isValidCandidate),
)

// File -> Promise[xlsx.workbook]
const readSpreadsheetFile = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    const decoder = new TextDecoder('utf-8')
    reader.onload = event => {
      try {
        const byteData = new Uint8Array(event.target.result)
        const sheet =
          extension(file.name) === 'csv'
            ? xlsx.read(decoder.decode(byteData), { type: 'string' })
            : xlsx.read(byteData, { type: 'array' })
        resolve(sheet)
      } catch (error) {
        reject(error)
      }
    }
    reader.onerror = reject
    reader.readAsArrayBuffer(file)
  })

// FileList -> Promise[[{k:v}]]
export const importCandidateSheet = files =>
  Promise.all(Array.from(files).map(readSpreadsheetFile)).then(processWorkbooks)

const getMimeType = filename =>
  ({
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    csv: 'text/csv',
  }[extension(filename)])

// String -> Promise[File]
export const templateDocument = (filename = 'candidate.template.xlsx') => {
  const row = {}
  for (const key of correctHeader) row[key] = ''
  return exportCandidateSheet([row], filename)
}

const columnWidths = R.pipe(
  R.converge(R.prepend, [
    R.pipe(
      R.head,
      R.keys,
    ),
    R.map(R.values),
  ]),
  R.transpose,
  R.map(
    R.pipe(
      R.filter(R.is(String)),
      R.map(R.length),
      R.reduce(R.max, 0),
      R.add(2),
      R.objOf('wch'),
    ),
  ),
)

export const getFileName = model => {
  const date = new Date().toISOString().slice(0, 10)

  return `ebber.${model}.${date}`
}

// [{k:v}] -> Promise[File]
export const exportCandidateSheet = (rows, fileName = 'data.xlsx') => {
  const worksheetName = 'data'
  const ext = extension(fileName)
  const worksheet = xlsx.utils.json_to_sheet(rows)
  // set column widths (32 chars)
  worksheet['!cols'] = columnWidths(rows)
  const workbook = xlsx.utils.book_new()
  xlsx.utils.book_append_sheet(workbook, worksheet, worksheetName)
  const writerOptions = { type: 'array', bookType: ext }
  const arrayBuffer = xlsx.write(workbook, writerOptions)
  return new Promise((resolve, reject) => {
    const file = new File([arrayBuffer], fileName, {
      type: getMimeType(fileName),
    })
    resolve(file)
  })
}
